/* tslint:disable */
require('./FieldTaxonomyRenderer.module.css');
const styles = {
  ellipsis: 'ellipsis_c1d1c2df',
  term: 'term_c1d1c2df',
  relative: 'relative_c1d1c2df',
  fabricIcon: 'fabricIcon_c1d1c2df',
};

export default styles;
/* tslint:enable */